import { Pipe, PipeTransform } from '@angular/core';

import { getSeason } from '../constants/constants';
import moment from 'moment';

@Pipe({
  name: 'getSeason',
  standalone: true,
})
export class GetSeasonPipe implements PipeTransform {
  transform(date?: moment.Moment) {
    return getSeason(date);
  }
}
